const parkingCharacteristics = [
  {
    id: 0,
    name: "Indoor",
  },
  {
    id: 1,
    name: "Underground",
  },
  {
    id: 2,
    name: "Lights",
  },
  {
    id: 3,
    name: "Video surveillance",
  },
  {
    id: 4,
    name: "Pushchair and luggage friendly",
  },
  {
    id: 5,
    name: "Valet",
  },
  {
    id: 6,
    name: "Disabled Parking available",
  },
  {
    id: 7,
    name: "Refundable Deposit Required",
  },
  {
    id: 8,
    name: "48 Hours Guarantee",
    canNotAdd: true,
  },
  {
    id: 9,
    name: "Allocated Parking",
  },
  {
    id: 10,
    name: "Unallocated Parking",
  },
  {
    id: 11,
    name: "Covered Parking",
  },
  {
    id: 12,
    name: "Individual Owner",
    canNotAdd: true,
  },
  {
    id: 13,
    name: "Requires Owner Approval",
    canNotAdd: true,
  },
  {
    id: 14,
    name: "Verified Business User",
    canNotAdd: true,
  },
  {
    id: 15,
    name: "5 Stars Rating - Great Reviews",
    canNotAdd: true,
  },
  {
    id: 16,
    name: "Near Metro",
  },
  {
    id: 17,
    name: "EV Charging Stations Available",
  },
  {
    id: 18,
    name: "Driver's License picture will be taken",
  },
]

export const parkingCharacteristicsManual = parkingCharacteristics.filter((characteristic) => (!characteristic.canNotAdd))
export default parkingCharacteristics
